module.exports = __webpack_public_path__ + "static/media/no-img-product.c33b6e7e.png";